import { render, staticRenderFns } from "./layoutScienceInnovation.vue?vue&type=template&id=12cc7e99&scoped=true&"
import script from "./layoutScienceInnovation.vue?vue&type=script&lang=js&"
export * from "./layoutScienceInnovation.vue?vue&type=script&lang=js&"
import style0 from "./layoutScienceInnovation.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./layoutScienceInnovation.vue?vue&type=style&index=1&id=12cc7e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc7e99",
  null
  
)

export default component.exports